import { render, staticRenderFns } from "./FileTypeIcon.vue?vue&type=template&id=2619dc95&scoped=true&"
import script from "./FileTypeIcon.vue?vue&type=script&lang=js&"
export * from "./FileTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileTypeIcon.vue?vue&type=style&index=0&id=2619dc95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2619dc95",
  null
  
)

export default component.exports